<script async setup lang="ts">
import { PhotoEntity } from '@/entities/interfaces/photos';
import { getImageLink } from '@/helpers/imageLink';
import { dateToText } from '@/helpers/dateToText';
import { computed, onMounted, ref } from 'vue';
import { EventEntity } from '@/entities/interfaces/events';
import { useEventStore } from '@/stores/events.store';
import { getPhotos } from '@/entities/api/photos';

const props = defineProps<{
  photo: PhotoEntity;
  styles?: string;
}>();

const eventStore = useEventStore();

const event = computed<EventEntity>(
  () =>
    eventStore.getEvents.value.filter(
      (event: EventEntity) => event.id == props.photo.eventId
    )[0]
);

const photos = ref<number>();

onMounted(() => {
  getPhotos(props.photo.eventId).then((res) => (photos.value = res.length));
});
</script>

<template>
  <RouterLink :to="`/gallery/${photo.eventId}`" class="photo" :style="styles">
    <div class="photo-image">
      <div class="filter" />
      <img :src="getImageLink(photo.imageId)" alt="" />
      <div class="photo-number">{{ photos }} фото</div>
    </div>
    <div class="photo-info">
      <p>{{ event.name }}</p>
      <time>{{ dateToText(event.plannedDateTime) }}</time>
    </div>
  </RouterLink>
</template>

<style scoped lang="scss">
.photo {
  width: 100%;
  margin: 12px;
  display: flex;
  height: 385px;
  flex: 1 440px;
  max-width: 676px;
  overflow: hidden;
  align-items: center;
  border-radius: 40px;
  position: relative;
  justify-content: center;
  flex-direction: column;
  background: var(--color-mono-10);

  &:hover {
    .photo-image {
      img {
        transform: scale(1.1);
      }

      .filter {
        opacity: 0.2;
      }
    }
  }

  &-number {
    right: 24px;
    bottom: 24px;
    padding: 4px 8px;
    overflow: hidden;
    position: absolute;
    border-radius: 32px;
    background: #27303e40;
    backdrop-filter: blur(3px);
    color: var(--color-mono-0);
  }

  &-image {
    width: 100%;
    height: 400px;
    overflow: hidden;
    position: relative;
    border-radius: 40px 40px 0 0;

    display: flex;
    align-items: center;
    justify-content: center;

    .filter {
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      position: absolute;
      transition: 0.3s ease-in-out;
      background: var(--color-mono-900);
    }

    img {
      min-width: 100%;
      min-height: 100%;
      object-fit: cover;
      transition: 0.3s ease-in-out;
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    min-height: 120px;
    max-height: 120px;
    height: 120px;
    padding: 24px;

    p {
      text-align: left;
      color: var(--color-mono-900);
      font-size: var(--font-size-m);
      line-height: 20px;
    }

    time {
      font-weight: var(--font-weight-light);
      color: var(--color-mono-400);
      font-size: var(--font-size-xs);
    }
  }
}
</style>
